import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import InstanceType from './instance_type';
import Template from './template';

@Model()
export default class TemplateInstanceTypeAssignment extends ApplicationRecord {
  static jsonapiType = 'template_instance_type_assignments';
  @Attr() position: number;

  @BelongsTo() template: Template;
  @BelongsTo() instanceType: InstanceType;
}
